import * as React from 'react';
import {
    Plan, PlanPackageCriterion,
} from 'fs-api-client';
import { PlanPackageView } from './PlanPackageView';
import { Providers } from 'portal-shared-lib';
import { BillingPlan, PlanPackage } from './BillingPlanModel';

const SubscriptionType = PlanPackageCriterion.SubscriptionTypeEnum;

const FilespaceTypeMap = {
    [SubscriptionType.Basic]: 'Basic Filespace',
    [SubscriptionType.Custom]: 'Custom Filespace',
    [SubscriptionType.Any]: 'Any Filespace',
    [SubscriptionType.Enterprise]: 'Enterprise Filespace',
    [SubscriptionType.Teams]: 'Teams Filespace',
    [SubscriptionType.None]: 'Legacy Filespace'
};

interface BillingPlanViewProps {
    billingPlan: BillingPlan;
    currency: string;
    canEdit: boolean;

    onEditClicked: (planPackage: PlanPackage, plan: Plan) => void;
    onDeleteClicked: (planPackage: PlanPackage, plan: Plan) => void;
}

interface BillingPlanViewState {
    billingPlan?: BillingPlan;
}

export class BillingPlanView extends React.Component<BillingPlanViewProps, BillingPlanViewState> {
    constructor(props: BillingPlanViewProps) {
        super(props);
    }

    render() {
        return this.renderBillingPlan(this.props.billingPlan);
    }

    private renderBillingPlan(billingPlan: BillingPlan): JSX.Element[] {
        return billingPlan.planPackages.map( (planPackage) => {
            return this.renderPlanPackageView(planPackage); });
    }

    private getFilespaceTypeHeader(planPackage: PlanPackage) {
        if (planPackage.isLite) {
            let providerStr = `(${planPackage.includeCriteria[0].storageProvider}`;
            if (planPackage.includeCriteria.length > 1) {
                providerStr = `${providerStr}, ${planPackage.includeCriteria[1].storageProvider}`;
            }
            providerStr = `${providerStr})`;

            return `Custom Lite Filespace ${providerStr}`;
        }

        const subscriptionType = planPackage.includeCriteria[0].subscriptionType;
        const storageProvider = planPackage.includeCriteria[0].storageProvider;

        if (subscriptionType !== PlanPackageCriterion.SubscriptionTypeEnum.Advanced) {
            return FilespaceTypeMap[subscriptionType];
        }

        if (storageProvider === Providers.AWS) {
            return 'LucidLink Classic Enterprise (AWS)';
        } else if (storageProvider === Providers.IBM) {
            return 'LucidLink Classic Advanced (IBM)';
        }

        if (planPackage.includeCriteria.length > 1) {
            return 'Multiple Filespaces';
        }

        return FilespaceTypeMap[planPackage.includeCriteria[0].subscriptionType];
    }

    private renderPlanPackageView(planPackage: PlanPackage): JSX.Element {
        const header = this.getFilespaceTypeHeader(planPackage);
        return (
            <PlanPackageView
                currency={this.props.currency}
                isNewPackage={false}
                onEditClick={this.props.onEditClicked}
                onDeleteClicked={this.props.onDeleteClicked}
                planPackage={planPackage}
                header={header}
                canEdit={this.props.canEdit}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/backoffice/components/billing/BillingPlanView.tsx